import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class CompensationService {
  // 获取模板接口
  getPlanTemplateList(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/getPlanTemplateList',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 获取可用的考勤处罚列表
  attendance(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/attendance',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 获取可用的投诉处罚列表
  complaint(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/complaint',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 薪资方案新增
  addSalary(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/add',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 薪资列表页
  getLists(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/getLists',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 薪资列表状态
  getStatusLists(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/getStatusLists',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 薪资方案删除
  Delete(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/delete',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 启用方案
  enable(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/enable',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 停用方案
  stop(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/stop',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 获取创建方案所需数据
  getCreateNeedData(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'attendance/getCreateNeedData',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 猎头端获取邀约列表
  getInvitation(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/getInvitation',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 薪资方案详情
  getInfo(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/getInfo',
      type: 'get',
      data: params,
      loading: true,
    });
  }

  // 获取全部启用方案
  getEnablePlan(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/getEnablePlan',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 获取全部启用方案
  salaryChange(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/change',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 查看方案使用人员
  getUseUserList(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/getUseUserList',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 查询邀约分配记录
  invitationUpdateLog(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'headhunting/invitationUpdateLog',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  // 查询邀约分配记录
  salaryCopy(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'salary/copy',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 修改方案
  editInfo(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'V2/salary/editInfo',
      type: 'post',
      data: params,
      loading: true,
    });
  }
  // 修改方案名称
  editName(params: any): Promise<unknown> {
    return this.commonService.ajax({
      url: 'V2/salary/editName',
      type: 'post',
      data: params,
      loading: true,
    });
  }

  constructor(public commonService: CommonService) {}
}
